import React from "react";
import { useTranslation } from "react-i18next";

export default function LayoutMobileMenu(props) {
    const { t } = useTranslation();

    const { items, onAddItem, getBlockName } = props;

    return (
        <div className="layout-mobile-menu">
            <div className="layout-mobile-menu-list">
                {items.map((item, index) => {
                    const name = getBlockName(item);

                    return (
                        <div
                            key={index}
                            className={`layout-mobile-menu-item`}
                            data-index={index}
                            data-step-name={name}
                            onClick={() => onAddItem(item)}
                        >
                            {t(`${name}`)}
                            {" +"}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
